import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { FormTrackerService } from '@unity/services/form-tracker.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FormChangesDeactivateGuard implements CanDeactivate<unknown> {
  private readonly formTrackerService = inject(FormTrackerService);

  public canDeactivate(
    _component: unknown,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): boolean | Observable<boolean> {
    const bypass = nextState.root.queryParamMap.has('success');
    if (bypass) {
      this.formTrackerService.clearFormList();
      return true;
    }

    let exiting = true;
    const unsavedForms = this.formTrackerService.getDirtyForms();

    if (unsavedForms.length > 0) {
      exiting = window.confirm('You have unsaved changes on this page. Are you sure you want to leave?');
    }
    if (exiting) {
      this.formTrackerService.clearFormList();
    }
    return exiting;
  }
}
